<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="(valor) => $emit('update:modelValue', valor)">
    <q-card style="min-width: 360px; max-width: 560px" data-test="dialogo-resolver">
      <q-card-section class="row items-center no-wrap">
        <div class="text-h6">{{ tituloResolucao }}</div>
        <q-space />
        <q-btn icon="close" flat round dense :disable="resolvendo" data-test="fechar-resolucao" @click="$emit('update:modelValue', false)" />
      </q-card-section>
      <q-card-section class="q-pt-none">
        <template v-if="isPagaEmConflito">
          <div class="q-mb-xs">O que foi decidido?</div>
          <div class="column">
            <q-radio
              v-for="opcao in DECISOES"
              :key="opcao.value"
              v-model="decisao"
              :val="opcao.value"
              :label="opcao.label"
              dense
              class="q-mb-xs"
              :data-test="`decisao-${opcao.value}`"
            />
          </div>
          <q-banner dense class="bg-blue-1 text-blue-10 q-my-sm" data-test="aviso-estorno">
            Para confirmar: o sistema não faz estorno automático. Se decidir devolver, faça a devolução por fora e registre aqui.
          </q-banner>
          <div v-if="decisao === 'devolver'" class="q-mb-sm" data-test="passos-devolucao">
            <div class="text-weight-bold">Faça à mão depois de devolver:</div>
            <ol class="q-my-xs q-pl-md">
              <li>Devolva o Pix ao cliente pelo banco ou pelo suporte DouraSoft.</li>
              <li>No financeiro, estorne o crédito da venda, a taxa de cobrança e a tarifa, se já tiverem sido lançados.</li>
              <li>No estoque, devolva os itens que tiverem sido baixados.</li>
            </ol>
          </div>
        </template>
        <q-input
          v-model="nota"
          type="textarea"
          autogrow
          outlined
          dense
          label="Nota"
          :maxlength="NOTA_MAX"
          data-test="nota-resolucao"
        />
        <q-banner v-if="erro" dense class="bg-red-1 text-negative q-mt-sm" data-test="erro-resolucao">{{ erro }}</q-banner>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          unelevated
          no-caps
          label="Resolver"
          color="primary"
          :loading="resolvendo"
          :disable="!nota.trim() || (isPagaEmConflito && !decisao)"
          data-test="confirmar-resolucao"
          @click="resolve"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
const NOTA_MAX = 500;

const DECISOES = [
  { label: "Honrar a venda", value: "honrar" },
  { label: "Devolver o valor por fora", value: "devolver" }
];

export default {
  name: "dialog-resolver-conflito",
  props: {
    modelValue: { type: Boolean, default: false },
    alvo: { type: Object, default: null }
  },
  emits: ["update:modelValue", "resolvido"],
  data() {
    return {
      NOTA_MAX,
      DECISOES,
      nota: "",
      decisao: null,
      erro: null,
      resolvendo: false
    };
  },
  computed: {
    tituloResolucao() {
      if (!this.alvo) return "";

      return this.alvo.venda ? `Resolver conflito da venda ${this.alvo.venda.codigo}` : "Resolver aviso sem venda";
    },
    isPagaEmConflito() {
      const venda = this.alvo && this.alvo.venda;

      return Boolean(venda && venda.status === "paga");
    }
  },
  watch: {
    modelValue(aberto) {
      if (!aberto) return;

      this.nota = "";
      this.decisao = null;
      this.erro = null;
    }
  },
  methods: {
    async resolve() {
      if (!this.nota.trim() || this.resolvendo || (this.isPagaEmConflito && !this.decisao)) return;

      this.resolvendo = true;
      this.erro = null;
      let resultado;
      try {
        resultado = this.alvo.venda
          ? await this.$store.dispatch("resolveVendaOnlineConflito", {
              id: this.alvo.venda.id,
              nota: this.nota.trim(),
              decisao: this.isPagaEmConflito ? this.decisao : null,
              ultimoEventoId: this.alvo.venda.ultimo_evento_id ?? null
            })
          : await this.$store.dispatch("resolveVendaOnlineAviso", { id: this.alvo.aviso.id, nota: this.nota.trim() });
      } finally {
        this.resolvendo = false;
      }

      if (!resultado.ok) {
        this.erro = resultado.mensagem;
        return;
      }

      this.$emit("update:modelValue", false);
      this.$q.notify({ message: resultado.mensagem, color: resultado.pendente ? "orange" : "green", position: "top-right" });
      this.$emit("resolvido");
    }
  }
};
</script>
